import React from "react";
import { Link } from "react-router-dom";

const ITEM_CLASS = "text-[#7a6b62] hover:text-[#b89a6d] transition-colors text-sm";

/**
 * A single labeled column of footer links. Renders <Link> for internal
 * paths and <a target="_blank"> with proper rel for external entries.
 */
export const FooterLinkColumn = ({ title, links, testid }) => (
  <div data-testid={testid}>
    <h4 className="text-[#3a2a26] font-semibold mb-4">{title}</h4>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.to}>
          {l.external ? (
            <a
              href={l.to}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className={ITEM_CLASS}
              data-testid={l.testid}
            >
              {l.label}
            </a>
          ) : (
            <Link to={l.to} className={ITEM_CLASS} data-testid={l.testid}>
              {l.label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  </div>
);

export default FooterLinkColumn;
